import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useChurchesStore } from '../store/churchesStore'
import { updateChurch } from '../utils/updateChurch'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUpdateChurchMutation = (onSuccess?: () => void) => {
  const update = useChurchesStore((state) => state.update)

  return useMutation({
    mutationFn: updateChurch,
    onSuccess: ({ message, church }) => {
      update(church)

      toast.success(message || 'Church edited successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while editing church.')
    },
  })
}
